
export const UriConstant = {
  URI_TMF620: "/TMFC001/TMF620/v5/",
  URI_TMF723: "/TMFC001/TMF723/v4/",
  URI_TMF671: "/TMFC001/TMF671/v5/",
  URI_TMF806: "/TMFC001/TMF806/v1/",
  URI_TMF807: "/TMFC001/TMF807/v1/",
  URI_TMF808: "/TMFC001/TMF808/v1/",
  URI_TMF809: "/TMFC001/TMF809/v1/",

  URI_TMF622: "/TMFC002/TMF622/v5/",
  URI_TMF648: "/TMFC002/TMF648/v5/",
  URI_TMF663: "/TMFC002/TMF663/v5/",
  URI_TMF679: "/TMFC027/TMF679/v5/",
  URI_TMF760: "/TMFC027/TMF760/v5/",

  URI_TMF637: "/TMFC005/TMF637/v5/",

  URI_TMF633: "/TMFC006/TMF633/v5/",
  URI_TMF657: "/TMFC006/TMF657/v4/",
  URI_TMF641: "/TMFC007/TMF641/v5/",
  URI_TMF638: "/TMFC008/TMF638/v5/",
  URI_TMF645: "/TMFC009/TMF645/v5/",
  URI_TMF634: "/TMFC010/TMF634/v5/",
  URI_TMF652: "/TMFC011/TMF652/v4/",
  URI_TMF639: "/TMFC012/TMF639/v5/",
  URI_TMF685: "/TMFC012/TMF685/v5/",
  URI_TMF697: "/TMFC061/TMF697/v5/",
  URI_TMF713: "/TMFC061/TMF713/v4/",
  URI_TMF714: "/TMFC061/TMF714/v4/",
  URI_TMF646: "/TMFC046/TMF646/v5/",
  URI_TMF802: "/TMFC100/TMF802/v1/",
  URI_TMF803: "/TMFC100/TMF803/v1/",
  URI_TMF804: "/TMFC102/TMF804/v1/",
  URI_TMF805: "/TMFC102/TMF805/v2/",

  URI_TMF701: "/TMFC003/TMF701/v5/",
  URI_TMF666: "/TMFC035/TMF666/v5/",

  // temporary URIs placed under TMFC001
  URI_TMF664: "/TMFC001/TMF664/v4/",
  URI_TMF669: "/TMFC035/TMF669/v5/",
  URI_TMF673: "/TMFC014/TMF673/v5/",
  URI_TMF674: "/TMFC014/TMF674/v5/",
  URI_TMF675: "/TMFC014/TMF675/v4/",
  URI_TMF629: "/TMFC001/TMF629/v5/",
  URI_TMF678: "/TMFC030/TMF678/v5/",
  URI_TMF683: "/TMFC023/TMF683/v5/",
  URI_TMF687: "/TMFC001/TMF687/v4/",
  URI_TMF662: "/TMFC001/TMF662/v4/",
  URI_TMF699: "/TMFC036/TMF699/v5/",
  URI_TMF632: "/TMFC028/TMF632/v5/",
  URI_TMF651: "/TMFC039/TMF651/v5/",
  URI_TMF676: "/TMFC029/TMF676/v4/",
  URI_TMF716: "/TMFC001/TMF716/v4/",
  URI_TMF801: "/TMFC001/TMF801/v5/",

  DynamicForm:"/dynamic-form"
};
